import { today } from 'owa-datetime';
import { createWeekDateRange } from 'owa-datetime-utils';
import React from 'react';
import { getUserWeekStartDay } from '../utils/getUserWeekStartDay';

import type { DateRange } from 'owa-datetime-utils';
export const getDefaultWeekRange = (): DateRange => {
    return createWeekDateRange(getUserWeekStartDay(), today());
};

export interface WeekRangeContextProps {
    dateRange: DateRange;
}

// Context used to track the current week date range.
export const WeekRangeContext: React.Context<WeekRangeContextProps> =
    React.createContext<WeekRangeContextProps>({
        /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
         * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
         *	> Function getDefaultWeekRange called at module scope is not allowed. This may cause unwanted side effects. */
        dateRange: getDefaultWeekRange(),
    });

export const useWeekRangeContext = (): WeekRangeContextProps => React.useContext(WeekRangeContext);
